import styled, { css } from 'styled-components';
import DataTable from '@components/DataTable';

interface SelectableProps {
  selected?: boolean;
}

const ColStyle = css`
  padding: ${({ theme }) => theme.x1spacePx}px 12px;
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;

export const CEOCompensationDataTable = styled(DataTable)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
    height: ${({ theme }) => theme.x4spacePx}px;
    background: ${({ theme }) => theme.color.darkerGray};
  }
  th {
    position: sticky;
    top: 0px;
    z-index: 1;
    ${ColStyle}
  }
  td {
    white-space: nowrap;
    vertical-align: middle;
    ${ColStyle}
  }
  caption {
    text-align: left;
  }
`;

export const TableRow = styled('tr')<SelectableProps>`
  position: relative;
  &&& {
    ${({ selected, theme }) =>
      selected && `background: ${theme.color.brand01RGBA(0.1)};`}
  }

  ${({ selected, theme }) =>
    selected &&
    css`
      &::after {
        content: ' ';
        display: block;
        position: absolute;
        width: 4px;
        background-color: ${theme.color.brand01};
        left: 0;
        top: 0;
        bottom: 0;
      }
    `}
`;
